export const MODAL_TEST_IDS = {
  root: 'modal',
};
